import React, { useState, useEffect } from "react"
import graphql from "babel-plugin-relay/macro"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { faExternalLinkAlt, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { useOutletContext } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box } from "theme-ui"
import ReactTooltip from "@huner2/react-tooltip"

import CodeEditor from "../../components/Radiate/CodeEditor/CodeEditor"
import NewBoxButton from "../../components/Radiate/NewBoxButton/NewBoxButton"
import Tab from "../../components/Radiate/Tab/Tab"
import BusinessInfo from "../../components/BusinessInfo/BusinessInfo"
import Preferences from "../../components/Preferences/Preferences"
import IceBreakersAndPersistentMenu from "../../components/IceBreakersAndPersistentMenu/IceBreakersAndPersistentMenu"
import LocaleGroupsSettings from "../../components/LocaleGroupsSettings/LocaleGroupsSettings"
// import  AgentsSettings from "../../components/AgentsSettings/AgentsSettings"
import {
  useQueryLoader,
  usePreloadedQuery,
} from "react-relay"

import * as Styles from "./SettingsStyles"

const OWN_DOMAIN = process.env.REACT_APP_OWN_DOMAIN
const ROUTER_BASE = process.env.REACT_APP_ROUTER_BASE || ""
let VERSION
if (ROUTER_BASE.length) {
  VERSION = ROUTER_BASE.slice(2)
}

const SettingsQuery = graphql`
  query SettingsQuery {
    businessViewer {
      id
      businessId
      defaultToken
      localeGroups {
        id
        name
        locales
        default
      }
      # woztellLocaleGroups {
      #   name
      #   locales
      # }
      profile {
        name
        legalName
        about
        phones {
          number
          alias
        }
        addresses {
          line1
          line2
          city
          state
          country
          alias
        }
        websites {
          url
          alias
        }
        emails {
          email
          alias
        }
        logoUrl
        botAgentImageUrl
      }
      chatConfiguration {
        themeColor
        customCss
        showAgentProfile
        localised {
          localeId
          persistentMenu {
            buttons
            enable
          }
          iceBreakers {
            ctas
            enable
          }
          inputPlaceholder
        }
      }
      agents {
        name
        icon
        email
        woztellUserId
        agentId
      }
      # woztellUsers {
      #   _id
      #   email {
      #      email
      #      verified
      #   }
      # }
    }
  }
`

const InnerSettings =({
  queryRef,
}) => {
  const data = usePreloadedQuery(
    SettingsQuery,
    queryRef,
  )
  const info = data?.businessViewer
  const [copyText, setCopyText] = useState("Copy")
  const [defaultOpen, setDefaultOpen] = useState(false)
  const [ref, setRef] = useState("")
  const [greetings, setGreetings] = useState("")
  const [locale, setLocale] = useState("")
  const [notReadyIconUrl, setNotReadyIconUrl] = useState("")
  const [notReadyText, setNotReadyText] = useState("")
  const [loadDelay, setLoadDelay] = useState(0)
  const [welcomeMessage, setWelcomeMessage] = useState("")
  let webchatUrl = `${OWN_DOMAIN}/v${VERSION}/messenger/?token=${info?.defaultToken}`
  if (welcomeMessage.length) {
    webchatUrl += `&welcomeMessage=${encodeURIComponent(welcomeMessage)}`
  }
  let bodyScriptOptions = {}
  if (defaultOpen) {
    bodyScriptOptions.defaultOpen = true
  } else {
    bodyScriptOptions.defaultOpen = false
  }

  if (ref.length) {
    bodyScriptOptions.ref = ref
  } else {
    delete bodyScriptOptions.ref
  }

  if (greetings.length) {
    bodyScriptOptions.greetings = greetings
  } else {
    delete bodyScriptOptions.greetings
  }

  if (locale.length) {
    bodyScriptOptions.locale = locale
  } else {
    delete bodyScriptOptions.locale
  }
  if (notReadyIconUrl.length) {
    bodyScriptOptions.notReadyIconUrl = notReadyIconUrl
  } else {
    delete bodyScriptOptions.notReadyIconUrl
  }
  if (notReadyText.length) {
    bodyScriptOptions.notReadyText = notReadyText
  } else {
    delete bodyScriptOptions.notReadyText
  }
  if (loadDelay || loadDelay === 0) {
    bodyScriptOptions.loadDelay = loadDelay || 0
  } else {
    delete bodyScriptOptions.loadDelay
  }

  if (welcomeMessage.length) {
    bodyScriptOptions.welcomeMessage = welcomeMessage
  } else {
    delete bodyScriptOptions.welcomeMessage
  }

  return (
    <div style={{ height: "100%", padding: "0 64px 40px 64px", background: "#ffffff" }}>
      {info?.defaultToken &&
        <>
          <div className="separator" style={{ height: "1px", width: "100%", background: "#e8e7e8" }} />
          <Styles.ContentWrapper>
            <div className="label">
              <div className="subtitle">Head Script</div>
            </div>

            <div className="info-content-wrapper" style={{ width: "70%" }}>
              <Styles.CodeEditorWrapper>
                <CodeEditor
                  id="code-editor-head"
                  mode="javascript"
                  showGutter={false}
                  className="webchat-script-code-editor code-editor"
                  readOnly
                  height={84}
                value={`// For http\n<script src="${OWN_DOMAIN.replace("https://", "http://")}/sdk.js"></script>\n\n// For https\n<script src="${OWN_DOMAIN}/sdk.js"></script>`}
                />
              </Styles.CodeEditorWrapper>
            </div>
          </Styles.ContentWrapper>
          <div className="separator" style={{ height: "1px", width: "100%", background: "#e8e7e8" }} />
          <Styles.ContentWrapper>
            <div className="label">
              <div className="subtitle">Body Script</div>
            </div>

            <div className="info-content-wrapper block" style={{ width: "70%" }}>
              <Box p={2}>
                <Styles.StyledCheckbox
                  label="Default Open"
                  value={defaultOpen}
                  onChange={(value) => {
                    setDefaultOpen(value)
                  }}
                />
                <Styles.StyledTextField
                  label="ref"
                  value={ref}
                  borderStyle
                  onChange={(e) => {
                    setRef(e.target.value)
                  }}
                />
                <Styles.StyledTextField
                  label="Greetings"
                  value={greetings}
                  borderStyle
                  onChange={(e) => {
                    setGreetings(e.target.value)
                  }}
                />
                <Styles.StyledTextField
                  label="Default Locale"
                  value={locale}
                  borderStyle
                  onChange={(e) => {
                    setLocale(e.target.value)
                  }}
                />
                <Styles.StyledTextField
                  label="Not Ready Icon URL"
                  value={notReadyIconUrl}
                  borderStyle
                  onChange={(e) => {
                    setNotReadyIconUrl(e.target.value)
                  }}
                />
                <Styles.StyledTextField
                  label="Not Ready Text"
                  value={notReadyText}
                  borderStyle
                  onChange={(e) => {
                    setNotReadyText(e.target.value)
                  }}
                />
                <Styles.StyledTextField
                  label="Load Delay"
                  value={loadDelay.toString()}
                  type="number"
                  useInput
                  borderStyle
                  onChange={(e) => {
                    setLoadDelay(parseInt(e.target.value))
                  }}
                />
                <Styles.StyledTextField
                  label="Welcome Message"
                  value={welcomeMessage}
                  borderStyle
                  onChange={(e) => {
                    setWelcomeMessage(e.target.value)
                  }}
                />
              </Box>
              
              <Styles.CodeEditorWrapper>
                <CodeEditor
                  id="code-editor-head"
                  mode="html"
                  showGutter={false}
                  height={100}
                  className="webchat-script-code-editor code-editor"
                  readOnly
                  value={`<script>
WoztellWebchat.init({
  version: "${VERSION}",
  token: "${info?.defaultToken}"
},${JSON.stringify(bodyScriptOptions)})
</script>`}
                />
              </Styles.CodeEditorWrapper>
            </div>
          </Styles.ContentWrapper>
        </>
      }
      {(info?.businessId && info?.defaultToken) &&
        <>
          <div className="separator" style={{ height: "1px", width: "100%", background: "#e8e7e8" }} />
          <Styles.ContentWrapper>
            <div className="label">
              <div className="subtitle">Test Your Bot</div>
            </div>
            <div className="info-content-wrapper" style={{ width: "70%" }}>
              <div className="url-container">
                <div className="url-wrapper">
                  <CopyToClipboard
                    text={webchatUrl}
                    onCopy={() => {
                      setCopyText("Copied")
                      setTimeout(() => {
                        setCopyText("Copy")
                      }, 5000)
                    }}
                  >
                    <div
                      className="webchat-path"
                      data-tip
                      data-for="copy-webchat-url"
                    >
                      <div className="url">{webchatUrl}</div>
                      <ReactTooltip
                        place="right"
                        effect="solid"
                        id="copy-webchat-url"
                        getContent={() => copyText}
                      />
                    </div>
                  </CopyToClipboard>
                </div>
                <div className="button-wrapper">
                  <a href={webchatUrl} target="_blank" rel="noopener noreferrer">
                    <NewBoxButton
                      primary
                      borderless
                      icon={faExternalLinkAlt}
                    />
                  </a>
                </div>
              </div>
            </div>
          </Styles.ContentWrapper>
        </>
      }
      <div className="separator" style={{ height: "1px", width: "100%", background: "#e8e7e8" }} />
      <Styles.ContentWrapper block>
        <Tab
          newTheme
          tabs={[{
            id: "business-info",
            text: "Business Info",
            content: (
              <BusinessInfo
                info={info}

              />
            )
          }, {
            id: "preferences",
            text: "Preferences",
            content: (
              <Preferences
                info={info}

              />
            )
          }, {
            id: "ib-pm",
            text: "Ice Breakers and Persistent Menu",
            content: (
              <IceBreakersAndPersistentMenu
                info={info}

              />
            )
          }, {
            id: "localeGroups",
            text: "Locale Groups",
            content: (
              <LocaleGroupsSettings
                info={info}

              />
            )
          }, 
          // {
          //   id: "agents",
          //   text: "Agents Settings",
          //   content: (
          //     <AgentsSettings
          //       info={info}

          //     />
          //   )
          // }
        ]}
        />
      </Styles.ContentWrapper>
    </div>
  )
}

const Settings = (props) => {
  const { encryption } = useOutletContext()
  const { payload } = encryption

  const [
    queryReference,
    loadQuery,
  ] = useQueryLoader(
    SettingsQuery,
    props.initialQueryRef, /* e.g. provided by router */
  )

  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      loadQuery()
    }
  }, [payload])
  
  if (queryReference) {
    return (
      <InnerSettings queryRef={queryReference} payload={payload} />
    )
  }
  return (
    <Styles.UnauthContainer>
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        style={{
          width: "2rem",
          height: "2rem",
          paddingBottom: "4px"
        }}
      />
      Something went wrong, please try again later.
    </Styles.UnauthContainer>
  )
}


export default Settings
